import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";
import { reducerPaths } from "../../app/reducerPaths";
import { VITE_NODE_SERVER_BASE_URL } from "../../utils/constants/urls/baseUrls"

export const authApi = createApi({
  reducerPath: reducerPaths.authApi,
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getResetPasswordLinkAgent: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `${VITE_NODE_SERVER_BASE_URL}/agent/resetPasswordLink`,
          body: payload
        }
      }
    }),
    resetPasswordAgent: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `${VITE_NODE_SERVER_BASE_URL}${`/agent/resetPassword`}`,
          body: payload
        }
      }
    }),
    getResetPasswordLinkAdmin: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `${VITE_NODE_SERVER_BASE_URL}/admin/resetPasswordLink`,
          body: payload
        }
      }
    }),
    resetPasswordAdmin: builder.mutation({
      query: ({ payload }) => {
        return {
          method: "POST",
          url: `${VITE_NODE_SERVER_BASE_URL}${`/admin/resetPassword`}`,
          body: payload
        }
      }
    })
  }),
});

export const {
  useResetPasswordAdminMutation,
  useGetResetPasswordLinkAdminMutation,
  useResetPasswordAgentMutation,
  useGetResetPasswordLinkAgentMutation
} = authApi;
